import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const editUserDetailsClient = async (user) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.editUserDetails()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
    });

    if (!res.ok) {
        return { error: true, message: 'edit user details request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default editUserDetailsClient;
